/**
 * Quick Actions Bar
 * @see Sprint 28 - US-28.1
 */

import { useNavigate } from 'react-router-dom';
import { ShoppingCart, ClipboardList, TrendingDown } from 'lucide-react';
import { Button } from '@/components/ui';
import { usePermission } from '@/hooks';

export function QuickActions() {
  const navigate = useNavigate();
  const canCreateOrder = usePermission('purchase-orders.create');
  const canCreateInventory = usePermission('inventories.create');
  const canCreateLoss = usePermission('losses.create');

  const hasAnyAction = canCreateOrder || canCreateInventory || canCreateLoss;

  if (!hasAnyAction) return null;

  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-2">
      {canCreateOrder && (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate('/achats/commandes/create')}
        >
          <ShoppingCart className="h-4 w-4" />
          Creer commande
        </Button>
      )}
      {canCreateInventory && (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate('/stock/inventaires/create')}
        >
          <ClipboardList className="h-4 w-4" />
          Faire inventaire
        </Button>
      )}
      {canCreateLoss && (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigate('/stock/pertes')}
        >
          <TrendingDown className="h-4 w-4" />
          Saisir perte
        </Button>
      )}
    </div>
  );
}
